/**
 * 自动生成， 请不要手工修改！
 */


export enum PlatformOfferType {
    FREE_SERVICE_PACKAGE
}
